import { Box, Link, Text } from "@chakra-ui/react";
import CommonHeaderBox from "components/CommonHeaderBox";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "TranslationContext";
import React from "react";

const PrivacyAndPolicy = () => {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <CommonHeaderBox justifyContent={"center"}>
        <Box
          cursor={"pointer"}
          onClick={() => navigate(-1)}
          zIndex={1}
          boxSize={"30px"}
          display={"grid"}
          placeItems={"center"}
          mr={"10px"}
          position={"absolute"}
          left={"15px"}
        >
          <ChevronLeftIcon color="white" fontSize={"28px"} />
        </Box>
        <Text>{translate["Usage_Agreement"]}</Text>
      </CommonHeaderBox>

      {/* Agreement Content */}
      <Box pt={"80px"}>
        <Box
          bg="#222126"
          borderRadius="lg"
          // maxH="500px"
          // overflowY="auto"
          p={4}
          mx="10px"
        >
          <Text fontSize="sm">
            发布日期：2024 年 9 月 1 日
            <br />
            生效日期：2024 年 9 月 1 日
            <br />
            前言：
            <br />
          </Text>
          <br />
          <Text>
            【家庭守护—手机定位看护防盗系统】（以下简称“我们”“本软件”“本服务”）手机应用软件是由黑龙江悟空科技有限责任公司（以下简称“我们”“本公司”）为您提供的一款手机定位看护防盗寻回产品，是帮助家长和孩子，老人建立一个良好的工作学习的生活环境，帮助孩子正确健康地使用手机，帮助家人对老人远程指导使用手机，查看安装应用防止安装诈骗软件，同时也能够实时查看周边环境，在必要时能提供及时帮助，丢失手机能够找回的一款双方信息共享的手机软件。
            <br />
            我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与服务时，我们可能会收集和使用您的相关信息，获取您的部分手机权限。我们希望通过【家庭守护—手机定位看护防盗系统】隐私协议（以下简称“本协议”）向您说明我们在您使用我们的产品与服务时如何收集、使用、保存这些信息，以及我们为您提供的访问、删除和保护这些信息的方式。
          </Text>
          <br />
          <br />
          <Text>
            一、【家庭守护—手机定位看护防盗系统】对个人信息的收集、使用
          </Text>
          <Text>
            根据《常见类型移动互联网应用程序必要个人信息范围规定》，【家庭守护—手机定位看护防盗系统】App属于“实用工具类”App，基本功能服务为“视频、录屏、录音、定位”，需要必要的个人信息，才可使用基本功能服务。我们非常重视用户的隐私和个人信息保护，我们将按照《网络安全法》等国家法律法规的相关要求采取相应安全保护措施，尽力保护您的个人信息安全可控。您在使用本产品时，我们可能会收集和使用您的相关信息。本隐私政策会向您说明我们在您使用本产品时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式：
          </Text>
          <br />
          <Text>
            清晰明确：我们将尽可能采用通俗易懂的文字为您阐释隐私政策，以便您能更清晰地了解我们如何保护和处理所收集的您的信息。
            <br />
            保障权益：我们将采取充分、合理的措施保障您的隐私权益。
            <br />
            尊重用户：我们尊重用户的选择权、知情权等权利的自由行使，允许您管理您的个人信息。
            <br />
            必要安全：我们仅收取必要的信息，并利用这些信息为您提供安全、详实的服务。
            <br />
            及时贴心：我们将随时聆听您的询问，并尽快为您解答您的疑问。
            希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并在是否选择服务以及选择何种服务时更加符合您的真实意思表示。
          </Text>
          <br />
          <Text>
            请您在注册或使用我们的服务前仔细阅读本政策，若您使用我们提供的服务，
            <br />
            即表示您认同我们在本政策中所述内容。
            <br />
            如您有问题，请联系我们。 <br />
            为更好的说明，本政策中的下列概念是指：
            <br />
            个人常用设备信息：指包括硬件序列号、MAC地址、软件列表、Android
            ID、IMEI、ICCID、IDFA、UDID、GUID、OAID、MEID、IP地址、SIM卡IMSI信息、陀螺仪、重力、加速器、传感器、WIFI信息BSSID/SSID、加速度传感器、已安装App信息和运行中进程信息等在内的描述个人常用设备基本情况的信息{" "}
            <br />
            个人GPS位置信息：指包括行踪轨迹、精准定位信息、粗略定位信息、经纬度等。
            常用的手机权限：相机、相册、存储权限、外存储权限、麦克风、剪切板，相机相册用于上传用户头像或图片，存储为缓存数据用户更好的浏览速度。
          </Text>
          <br />
          <Text>（一）具体功能及其所需处理的个人信息</Text>
          <br />
          <Text>1. 用户注册/登录 必要信息、非必要信息范围：</Text>
          <br />
          <Text>
            当您使用注册功能时，按照法律规定手机实名制要求，您必须向我们提供您本人的手机号码（手动输入）用于注册账号，我们将通过向该手机号发送短信验证码的方式来验证您的身份是否有效，可以根据自身需求自主设置您的账户密码。此类信息属于该功能的必要信息，若您不提供，您将无法完成注册。您可以后续完善账号信息，如绑定邮箱地址、第三方账号（如微信等）；此类信息属于该功能的非必要信息，如您拒绝提供该类信息会降低账号安全保护能力，但不影响使用注册功能。
          </Text>
          <br />
          <Text>
            当您使用登录功能时，您需要提供账号密码进行登录。当您忘记登录密码需要更改密码时，您需提供正确的预留手机号，回答正确的密保问题，系统会配合您更改密码，用于登录。
            收集这些信息是为了帮助您完成账号的注册，保护账号安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律、法规关于网络实名制要求。若您不提供这类信息，您可能无法正常使用我们的服务。
          </Text>
          <br />
          <Text>
            当您使用产品的过程中以及 app
            退到后台后或重启后可能会获取您的安卓ID信息（ 我们己方以及 uni 统计
            SDK ），目的是收集信息
            用于提供统计分析服务，方便定位产品异常情况下的问题分析，以便更好、更快地为您服务。
          </Text>
          <br />
          <Text>
            调用的敏感权限
            用户注册/登录当您注册账号时，我们会收集一些个人信息，手机号码、微信的
            openID 和 unionID ， 手机的厂商机型， IMEI ， IMSI ， Android ID
            安卓版本号
            ，cpu型号、设备型号、操作系统，此类信息为必要信息，若你拒绝提供该信息可能会对使用软件造成影响。
            使用的第三方SDK
            用户注册/登录，使用友盟移动统计SDK，【蓝色守护—手机定位看护防盗寻回系统】会获取联网、网络状态变化、WiFi状态变化、读取手机状态信息共享给第三方SDK（友盟移动统计SDK），此类信息适用于在友盟平台统计用户软件使用情况。此类信息为必要信息，用户如果拒绝提供可能会影响正常使用软件。
          </Text>
          <br />
          <Text>二、【家庭守护—手机定位看护防盗系统】收集哪些信息</Text>
          <br />
          <Text>
            我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您同意主动提供您的个人敏感信息，即表示您同意我们按本协议所述目的和方式来处理您的个人敏感信息。
            <br />
          </Text>
          <Text>
            1. 您在使用我们服务时需要主动提供的信息 您在注册账户时填写的信息
            例如，您在注册账户时所填写的昵称、邮箱、手机号码
            您在使用服务时上传的信息
            例如，您在使用产品时，上传的头像、照片、视频，进行云备份时手机上的短信等数据
            您通过我们的客服或参加我们举办的活动时所提交的信息
            例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息
          </Text>
          <br />
          <Text>
            2. 我们在您使用服务时获取的信息 <br />
            日志信息
            <br />
            当您使用【家庭守护—手机定位看护防盗系统】服务时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您的设备型号、操作系统、唯一设备标识符（指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备）、登录IP地址、【家庭守护—手机定位看护防盗系统】软件版本号、接入网络的方式、类型和状态、网络质量数据）、操作日志、服务日志信息（如您在【家庭守护—手机定位看护防盗系统】进行搜索、查看操作的记录、服务故障信息、引荐网址等信息）、IMEI、IMISI等信息，这类信息是为提供服务必须收集的基础信息。
          </Text>
          <br />
          <Text>
            设备信息
            <br />
            例如，设备型号、操作系统版本、唯一设备标识符、电池等信息
          </Text>
          <br />
          <Text>
            软件信息
            <br />
            例如，软件的版本号、类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息
          </Text>
          <br />
          <Text>
            位置信息
            <br />
            当您使用与位置有关的服务时，我们可能会记录您和被守护儿童，老人设备所在的位置信息，我们可能会通过IP地址、GPS、蓝牙、WiFi或基站等途径获取您的地理位置信息以便为您提供相关服务，您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的账号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息，该信息属于敏感信息，拒绝提供该信息仅会使您无法使用上述位置服务，但不影响您正常使用其他【家庭守护—手机定位看护防盗系统】的功能。
          </Text>
          <br />
          <Text>
            其他相关信息
            <br />
            为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。
          </Text>
          <br />
          <Text>
            三、【家庭守护—手机定位看护防盗系统】如何使用和管理个人信息
            <br />
            （一）我们如何使用这些个人信息
            <br />
            您理解并同意黑龙江悟空科技有限责任公司可在以下事项中使用用户的个人隐私信息，我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途：若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。
            <br />
            1. 产品开发和服务优化，提供更好的服务。
            <br />
            为了让您有更好的用户体验，同时改善我们的服务或出于经您同意的其他用途，在符合相关法律、法规规定的前提下，我们可能会将通过某些服务所收集的信息用于我们的其他服务
            。
            例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息。当您向客服提出疑问时，根据我们收集的数据和您提供的数据，帮助我们定位问题，并帮您解决问题，依本协议约定，为了管理、审查用户信息及进行处理措施。
            <br />
            2.为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，
            例如，当您账号丢失或者由于其他原因寻求我们帮助时，我们使用这些信息来确认您的身份信息，确保账号安全。我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。为了向用户及时发送重要通知，如软件更新、本协议条款的变更。
            <br />
            3.您可以在使用我们服务的过程中，访问、修改和删除您提供的个人信息，也可按照通知指引与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。
            <br />
            4.从第三方合作伙伴获取的信息。我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。您使用微信登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间，
            方便您进行授权管理。请您仔细阅读第三方合作伙伴服务的用户协议或本协议
            （ 我们所有的第三方合作伙伴信息均已在上文列出 ） 。
            <br />
            （二）我们如何管理您的个人信息 <br />
            我们将按照本协议所述，仅为实现向您提供更好的产品和服务而使用您的信息。如您发现我们没有按照本协议的约定，收集和使用您的个人信息，个人信息主体可以向我们提出访问、纠正、删除我们所保留的相关个人信息的请求（下文统称
            “ 请求 ” ）。
            您也可以选择拒绝提供个人信息或要求我们停止自动收集信息。在某些情况下，如果您决定不提供消息，您将无法访问请求的网页或者不能使用我们的产品和服务。请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求。
            <br />
          </Text>
          <Text>
            访问、纠正、删除提出请求的方式与渠道
            个人信息主体请求必须以书面形式提出。一般来说，口头提出的访问请求是无效的，如果个人信息主体通过热线、服务邮箱、在线客服、官方网站等其他渠道
            提出相关请求，我们会引导个人信息主体通过前述渠道提出正式请求，以便于交流和反馈处理进度及结果。我们建立专门的个人信息主体请求渠道，旨在保护个人信息主体的合法利益和保障我们的正常经营，防止个人信息请求权利被他人盗用或者滥用。
            <br />
            1.请求的有效性
            <br />
            大多数的法律要求个人信息主体提出请求的时候遵循特定的要求。本协议要求个人信息主体做到以下几点：
            <br />
            （ 1 ）通过我们专门的个人信息主体请求渠道（即
            通过热线、服务邮箱、在线客服、官方网站）提出请求；
            <br />
            （ 2
            ）提供足够的信息给我们来验证您的身份（以确保提出请求的人是个人信息主体本人）；
            <br />
            （ 3 ）请求内容具体，具有可执行性。
            <br />
            2. 请求的处理期限 <br />
            我们会竭尽全力确保在个人信息主体请求提出的最短时间内作出回复，考虑到要求的复杂性和数量，在必要的时候，这一期限可能延长。对于延期提供信息的情况，我们将通知个人信息主体相关情形和延迟原因。
            <br />
            3. 请求的结果
            <br />
            个人信息主体请求提出后，将可能出现以下几种结果：
            <br />
            （ 1 ）请求被驳回
            <br />
            在某些情况下，个人信息主体的请求将被驳回，包括但不限于：
            法律未赋予个人信息主体享有相关权利时；
            提出请求的人的身份无法被验证时；
            个人信息主体提出的要求无法验证、超出范围，尤其是重复提起要求的情形时；
            如果涉及的信息跟我们在纠纷中要做出的赔偿或者获得的补偿有关，披露信息很有可能会损害我们的利益时；
            如果保留信息只是出于统计和研究的目的，而且统计和研究结果的公布不会披露个人身份时；
            其他法律规定的情形。
            如果我们驳回了个人信息主体访问请求，将正式向请求人说明原因。
            <br />
            （ 2 ）请求成功 <br />
            当（ 1
            ）中的情形未发生时，我们会满足个人信息主体的请求。为了提升请求成功的可能性，
            请在提出请求时尽可能提供详细的信息，如请求的类别和具体内容、信息持有人的相关信息（如您所使用的我们产品及服务的名称）、信息生成或者处理的时间范围（时间范围越小，成功的可能性越大）等。
            <br />
            4. 特别声明
            <br />
            原则上我们不会提供以下信息：
            <br />
            关于其他人的信息 ——
            个人信息主体访问请求想要获取的数据可能会涉及个人信息主体之外的其他人。除非所涉及的个人同意，否则我们不会提供此类信息。
            重复申请 ——
            请求人提出的是针对同一个人信息主体的相同或者类似请求，且数据在过去一段时间内没有发生变化，而且我们已经提供了数据，或者获取和提供信息会耗费不相称的资源，这种情况下通常我们不会再提供数据的副本。此外，我们不提供已经公诸于众的信息。
            保密条件下给出的观点 ——
            如果关于个人信息主体的信息是需要在保密条件下给出的观点，我们不提供此类信息。
            特殊文件 ——
            我们保留的任何特殊信息是不会应个人信息主体的访问请求予以公开的。一般而言，特殊信息包括任何保密文件（例如客户与其律师之间的直接沟通）以及为取得或给出相应法律意见的信息（不论是诉讼本身或法院诉讼的过程中所涉及的信息），或有可能产生纠纷的信息。
            <br />
          </Text>
          <Text>
            四、我们如何使用Cookie、同类技术和SDK技术
            <br />
            （ 一 ）什么是Cookie
            <br />
            Cookie是您登录网站或浏览网络内容时，网站服务器存放在您的电脑、移动电话或其他智能终端设备内的小型文件，通常包含标识符、站点名称以及一些号码和字符。当您再次访问相应网站时，网站就可通过
            Cookie 识别您的浏览器。Cookie可能会存储用户偏好及其他信息。
            <br />
            （ 二 ）如何使用Cookie
            <br />
            当您使用【家庭守护—手机定位看护防盗系统】时，我们可能通过Cookies或同类技术收集您的设备型号、操作系统、设备标识符、登录IP地址信息，以及缓存您的浏览信息、点击信息，以查看您的网络环境。通过Cookies，我们可以在您访问网站时识别您的身份，并不断优化网站的用户友好程度，并根据您的需要对网站做出调整。您也可以更改浏览器的设置，使浏览器不接受我们网站的Cookies，但这样可能会影响您对网站的部分功能的使用。在【家庭守护—手机定位看护防盗系统】，借助于Cookie和其他类似技术，我们可以在您每次使用产品与/或服务时识别您是否属于我们的用户，而不必在每个页面上重新登录和验证。
            <br />
            （ 三 ）如何管理Cookie
            您可以根据自己的偏好管理或删除某些类别的追踪技术。很多网络浏览器均设有“禁止追踪”（Do
            Not
            Track）功能，该功能可向网站发布“禁止追踪”的请求。除了我们提供的控件之外，您还可以选择在Internet浏览器中启用或禁用Cookie。大多数互联网浏览器还允许您选择是要禁用所有Cookie还是仅禁用第三方Cookie。默认情况下，大多数互联网浏览器都接受Cookie，但这可以更改。有关详细信息，请参阅Internet浏览器中的帮助菜单或设备随附的文档。为确保网站正常运转、为您获得更轻松的访问体验，我们可能会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。您可以在浏览器中进行相应的数据清除操作。
            <br />
            其他技术
            <br />
            除Cookie外，我们还会在网站上使用其他同类技术。
            <br />
            第三方SDK
            <br />
            当你使用第三方提供的服务时，我们会在获得或确保第三方获得你的授权同意后，以及其他符合法律法规规定的情形下共享对应信息。你可以通过本清单中列举的相关信息了解第三方会何处理你的个人信息。
            <br />
          </Text>
          <Text>
            为保障App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的SDK实现相关目的，具体接入的相关第三方SDK列表如下：
            <br />
            1、阿里移动推送 SDK <br />
            第三方名称：阿里云计算有限公司 <br />
            收集个人信息类型：设备信息，包括操作系统、设备型号，IP ，运营商信息
            <br />
            使用目的：用于识别推送设备，实现向单个设备推送功能
            <br />
            使用场景：消息推送集成 收集个人信息的方式：SDK获取
            <br />
            隐私政策链接：
            <Link
              color="blue.400"
              href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html"
            >
              https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html
            </Link>{" "}
            <br />
            2、百度定位SDK <br />
            第三方名称：北京百度网讯科技有限公司 <br />
            收集个人信息类型：设备信息【包括设备标识信息（Android
            ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、
            位置信息【可能包括经纬度、GNSS信息、WiFi网关地址、WiFi
            MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、
            网络类型【如移动网络、WiFi网络】 <br />
            使用目的：为用户提供定位功能及服务 <br />
            使用场景：手机定位、位置共享等功能的实现 <br />
            收集个人信息的方式：SDK直接收集，不涉及数据传输共享 <br />
            隐私政策链接：
            <Link
              color="blue.400"
              href="https://lbs.baidu.com/index.php?title=openprivacy"
            >
              https://lbs.baidu.com/index.php?title=openprivacy
            </Link>{" "}
            <br />
            3、百度鹰眼轨迹SDK <br />
            第三方名称：北京百度网讯科技有限公司
            收集个人信息类型：设备信息【包括设备标识信息（Android
            ID、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、
            位置信息【可能包括经纬度、GNSS信息、WiFi地址及信号强度信息、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、传感器信息、设备信号强度信息、IP地址和蓝牙信息】网络类型【如移动网络、WiFi网络】
            <br />
            使用目的：为用户提供轨迹功能及服务 <br />
            使用场景：活动轨迹，电子围栏等功能的实现 <br />
            收集个人信息的方式：SDK直接收集，不涉及数据传输共享 <br />
            隐私政策链接：
            <Link
              color={"blue.400"}
              href="https://lbs.baidu.com/index.php?title=openprivacy"
            >
              https://lbs.baidu.com/index.php?title=openprivacy
            </Link>{" "}
            <br />
            4、七牛云实时音视频 SDK <br />
            第三方名称：上海七牛信息技术有限公司 <br />
            收集个人信息类型：设备信息（包括厂商、机型、系统版本、Android
            ID）、麦克风、相机、网络状态、捕获屏幕 <br />
            使用目的：用于判断用户的手机类型和网络状况，实时播放与编辑音视频流数据，实现语音视频通话功能{" "}
            <br />
            使用场景：实时语音、实时视频、屏幕共享功能的实现 <br />
            收集个人信息的方式：SDK获取 <br />
            隐私政策链接：
            <Link
              color="blue.400"
              href="https://developer.qiniu.com/pili/8027/sdk-privacy-policy"
            >
              https://developer.qiniu.com/pili/8027/sdk-privacy-policy
            </Link>{" "}
            <br />
            5、QPlayer2 播放器 SDK <br />
            第三方名称：上海七牛信息技术有限公司 <br />
            收集个人信息类型：设备品牌、型号、操作系统版本、处理器信息、网络类型及连接信息{" "}
            <br />
            使用目的：提供音视频播放服务 <br />
            使用场景：即使录音录像功能录制完成后，用于播放录音录像文件 <br />
            收集个人信息的方式：SDK获取 <br />
            隐私政策链接：
            <Link
              color={"blue.400"}
              href="https://developer.qiniu.com/pili/8027/sdk-privacy-policy"
            >
              https://developer.qiniu.com/pili/8027/sdk-privacy-policy
            </Link>
            <br />
            6、Bugly SDK <br />
            第三方名称：深圳市腾讯计算机系统有限公司 <br />
            收集个人信息类型：设备信息(包括手机型号、厂家、品牌、系统版本、CPU架构)、网络类型、应用当前正在运行的进程名和PID{" "}
            <br />
            使用目的：排查崩溃问题,帮助APP提升稳定性 <br />
            使用场景：收集bug信息 <br />
            收集个人信息的方式：SDK获取 <br />
            隐私政策链接：
            <Link
              color="blue.400"
              href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
            >
              https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
            </Link>{" "}
            <br />
            7、友盟+SDK <br />
            第三方名称：友盟同欣（北京）科技有限公司 <br />
            收集个人信息类型：设备信息（IMEI/MAC/Android
            ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息{" "}
            <br />
            使用目的：在APP内使用分享功能将APP分享给好友 <br />
            使用场景：分享APP <br />
            收集个人信息的方式：SDK获取 <br />
            隐私政策链接：{" "}
            <Link color={"blue.400"} href="https://www.umeng.com/page/policy">
              https://www.umeng.com/page/policy
            </Link>
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default PrivacyAndPolicy;
